import React, { Component } from 'react';
import { Form, FormGroup, Button, Label, Input, Container, Row, Col } from 'reactstrap';
//img

import './Contactenos.scss';
import imguno from '../Contactenos/img/Contactenos.jpg'
import axios from 'axios';
// import { createPortal } from 'react-dom';
// import { copySync } from 'fs-extra';

class Contactenos extends Component {
  constructor(){
  super()
    this.submitFormulario = this.submitFormulario.bind(this);
    this.onChangeNombres = this.onChangeNombres.bind(this);
    this.onChangeApellido = this.onChangeApellido.bind(this);
    this.onChangeCorreo = this.onChangeCorreo.bind(this);
    this.onChangeAsunto = this.onChangeAsunto.bind(this);
    this.onChangeMensaje = this.onChangeMensaje.bind(this);
    this.state ={
      nombres:'',
      apellido: '',
      correo: '',
      asunto: '',
      mensaje: ''
    }
    
  }
  onChangeNombres(e){
    this.setState({nombres: e.target.value})
  }
  onChangeApellido(e){
    this.setState({apellido: e.target.value})
  }
  onChangeCorreo(e){
    this.setState({correo: e.target.value})
  }
  onChangeAsunto(e){
    this.setState({asunto: e.target.value})
  }
  onChangeMensaje(e){
    this.setState({mensaje: e.target.value})
  }
  submitFormulario(e){
    e.preventDefault()
    const mensajeObject ={
      nombres: this.state.nombres,
      apellido: this.state.apellido,
      correo: this.state.correo,
      asunto: this.state.asunto,
      mensaje: this.state.mensaje
    };
    axios.post('http://localhost:4000/mensaje/correo', mensajeObject)
    .then((res)=>{
      console.log(res.data)
    }).catch((error)=>{
      console.log("this is "+ error)
    });
    this.setState({nombres: '', apellido:'', correo: '', asunto:'', mensaje:''})

    
  }
/*  componentDidMount(){
    window.scrollY = () =>{
      if (window.scrollY > 30)
        this.setState( prevState => {
          console.log("da mas");
        })
      else{
        this.setState(prevState => {
          console.log("Da meno");
        })
      }
    }

  }
  myRef(){
    console.log("logrado");
    window.scrollTo("0", "100")
  }
 */
  render() {
    return (
      <div className={"contactenos"} >
        <div className={"contactenos-"}>
          <img src={imguno} className={"LogoContactenos"} alt="portada" />
        </div>
        <div className="Contactenos-div">
          <h1 className="Text-contactenos">Contactenos</h1>
          <Container>
            <Row>
              <Col xs="12" sm="7">
                <div className={"form-contactenos"}>
                  <Form onSubmit={this.submitFormulario} className={"FormLI"} >
                    <FormGroup className={"FormName"}>
                      <Label>Nombres*</Label>
                        <Input value={this.state.nombres} onChange={this.onChangeNombres}  title="First Name" type="title" name="title" placeholder="First Name"/>
                        <Input value={this.state.apellido} onChange={this.onChangeApellido} title="Last Name" type="title" name="title" placeholder="Last Name"/>
                    </FormGroup>
                    <FormGroup className="ForInptutContact" >
                      <Label>Correo*</Label>
                      <Input value={this.state.correo} onChange={this.onChangeCorreo} type="Email" placeholder="Email" />
                    </FormGroup>
                    <FormGroup className="ForInptutContact"  >
                      <Label>Asunto*</Label>
                      <Input value={this.state.asunto} onChange={this.onChangeAsunto} type="text" placeholder="Asunto" />
                    </FormGroup>
                    <FormGroup className="ForInptutContact" >
                      <Label for="exampleText" placeholder="Mensaje" >Mensaje*</Label>
                      <Input value={this.state.mensaje} onChange={this.onChangeMensaje} type="textarea"id="exampleText" />
                    </FormGroup>
                    <Button   >SUBMIT</Button>
                  </Form>
                </div>
              </Col>
              <Col xs="12" sm="5">
                <div className="Inf-contactenos" >
                  <Col xs="12" className="div-inf">
                    <h1>Informacion</h1>
                      <h5><strong>COLOMBIA  BOGOTÀ D.C. </strong></h5>
                      <h5><strong>Email:</strong> jhonatancasas836@gmail.com</h5>
                      <h5><strong>Cel:</strong> 313-280-7189</h5>
                  </Col>
                  <Col xs="12" className="div-redes">
                    <a href="https://twitter.com/portaprent" target="_blank" rel='noreferrer noopener ' >
                      <i className="fab fa-twitter-square twitter" ></i>
                    </a>
                    <a href="https://www.instagram.com/portaprent/" target="_blank" rel='noreferrer noopener ' >
                      <i className="fab fa-instagram instagram" ></i>
                    </a>
                    <a href="https://www.facebook.com/portaprent" target="_blank" rel='noreferrer noopener ' >
                      <i className="fab fa-facebook-square facebook" ></i>
                    </a>
                  </Col>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }
};

export default Contactenos;



// WEBPACK FOOTER //
// ./src/Pages/Contactenos/Contactenos.jsx